import { utils } from 'components/lexemes';
import Localization from 'lib/localization';

export default {
  tab: {
    title() {
      return Localization.get('bumblesite@privacy.informationStoring.tab.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.informationStoring.tab.description', {
        link_information_usage: utils.getLinkMarkerUrl('link_information_usage'),
      });
    },
    contents: {
      title() {
        return Localization.get('bumblesite@privacy.informationDisclosure.tab.contents.title');
      },
      item1() {
        return Localization.get('bumblesite@privacy.informationStoring.tab.contents.item1');
      },
      item2() {
        return Localization.get('bumblesite@privacy.informationStoring.tab.contents.item2');
      },
    },
  },
  subsection1: {
    text1() {
      return Localization.get('bumblesite@privacy.informationStoring.subsection1.text1');
    },
    text2() {
      return Localization.get('bumblesite@privacy.informationStoring.subsection1.text2', {
        link_profile_verification_information: utils.getLinkMarkerUrl(
          'link_profile_verification_information',
        ),
      });
    },
    text3() {
      return Localization.get('bumblesite@privacy.informationStoring.subsection1.text3', {
        link_customer_support_contact_information: utils.getLinkMarkerUrl(
          'link_customer_support_contact_information',
        ),
      });
    },
  },
  subsection2: {
    title() {
      return Localization.get('bumblesite@privacy.informationStoring.subsection2.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.informationStoring.subsection2.text');
    },
    goodToKnow: {
      title() {
        return Localization.get('bumblesite@privacy.goodToKnow');
      },
      content1() {
        return Localization.get(
          'bumblesite@privacy.informationStoring.subsection2.goodToKnow.content1',
        );
      },
      content2() {
        return Localization.get(
          'bumblesite@privacy.informationStoring.subsection2.goodToKnow.content2',
        );
      },
    },
    example: {
      title() {
        return Localization.get('bumblesite@privacy.informationStoring.subsection2.example.title');
      },
      content() {
        return Localization.get(
          'bumblesite@privacy.informationStoring.subsection2.example.content',
        );
      },
    },
    exampleRight: {
      content1() {
        return Localization.get(
          'bumblesite@privacy.informationStoring.subsection2.exampleRight.content1',
        );
      },
      content2() {
        return Localization.get(
          'bumblesite@privacy.informationStoring.subsection2.exampleRight.content2',
        );
      },
    },
  },
  subsection3: {
    title() {
      return Localization.get('bumblesite@privacy.informationStoring.subsection3.title');
    },
    content1() {
      return Localization.get('bumblesite@privacy.informationStoring.subsection3.content1');
    },
    content2() {
      return Localization.get('bumblesite@privacy.informationStoring.subsection3.content2');
    },
    content3() {
      return Localization.get('bumblesite@privacy.informationStoring.subsection3.content3', {
        link_eu_scc: utils.getLinkMarkerUrl('link_eu_scc'),
      });
    },
  },
};
